// PRTable Component
const PRTable = () => (
        <div className="overflow-x-auto">
                <table className="table table-bordered w-full">
                        <thead>
                                <tr>
                                        <th></th>
                                        <th colSpan="2">Monday</th>
                                        <th colSpan="2">Tuesday</th>
                                        <th colSpan="2">Wednesday</th>
                                        <th colSpan="2">Thursday</th>
                                        <th colSpan="2">Friday</th>
                                </tr>
                        </thead>
                        <tbody>
                                {/* CR 1 */}
                                <PRSection
                                        roomName="PR 1"
                                        data={[
                                                {
                                                        doctor: 'Nick',
                                                        activity: 'PR',
                                                        time: '1:00-1:15pm'
                                                },
                                                // Add more days
                                        ]}
                                />
                                {/* CR 2 */}
                                <PRSection
                                        roomName="PR 2"
                                        data={[
                                                {
                                                        doctor: 'Paul',
                                                        activity: 'PR',
                                                        time: '1:00-1:15pm'
                                                },
                                                // Add more days
                                        ]}
                                />
                                {/* CR 3 */}
                                <PRSection
                                        roomName="PR 3"
                                        data={[
                                                {
                                                        doctor: 'Leigh',
                                                        activity: 'PR',
                                                        time: ''
                                                },
                                                // Add more days
                                        ]}
                                />
                        </tbody>
                </table>
        </div>
);

// PRSection Component
const PRSection = ({ roomName, data }) => (
        <>
                <tr>
                        <th rowSpan="4">{roomName}</th>
                </tr>
                <tr className="border-t-2 border-gray-300">
                        <th>Doctor</th>
                        <td>{data[0]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[1]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[2]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[3]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[4]?.doctor}</td>
                </tr>
                <tr>
                        <th>Activity</th>
                        <td>{data[0]?.activity}</td>
                        <th>Activity</th>
                        <td>{data[1]?.activity}</td>
                        <th>Activity</th>
                        <td>{data[2]?.activity}</td>
                        <th>Activity</th>
                        <td>{data[3]?.activity}</td>
                        <th>Activity</th>
                        <td>{data[4]?.activity}</td>
                </tr>
                <tr>
                        <th>Time</th>
                        <td>{data[0]?.time}</td>
                        <th>Time</th>
                        <td>{data[1]?.time}</td>
                        <th>Time</th>
                        <td>{data[2]?.time}</td>
                        <th>Time</th>
                        <td>{data[3]?.time}</td>
                        <th>Time</th>
                        <td>{data[4]?.time}</td>
                </tr>
        </>
);

export default PRTable;